import styled from 'styled-components';
/*
 *风格一样，使用的为input风格
 */
export const DatePickerSearchMLStyled = styled.div`
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-form-item-label {
    margin-right: 19px;
  }
  .ant-form-item-no-colon {
    width: ${(props) => props.labelwidth};
    height: ${(props) => props.height};
    display: flex;
    justify-content: center;
    background: ${(props) => props.theme[props.brand].formInput.singInputBg};
    /* color: ${(props) => props.theme[props.brand].formInput.color}; */
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    border-radius: 0px;
  }
  .ant-picker {
    width: 100%;
    min-width: ${(props) => props.inputWidth} !important;
    max-width: ${(props) => props.maxWidth} !important;
    padding-top: 0;
    padding-bottom: 0;
    background: ${(props) => props.theme[props.brand].formInput.inputBg};
    border: 0px;
  }
  .ant-picker-input {
    input {
      height: ${(props) => props.height};
      background: ${(props) => props.theme[props.brand].formInput.inputBg};
      color: ${(props) =>
        props.theme[props.brand].formInput.inputContentColor} !important;
      font-size: 16px;
      border-radius: 0px;
      border-color: ${(props) => props.theme[props.brand].formInput.inputColor};
    }
  }
  .ant-picker-input-disabled {
    color: ${(props) => props.theme[props.brand].formInput.color};
    cursor: default;
  }
  .ant-picker-input > input:hover,
  .ant-picker-focused,
  .ant-picker:hover,
  .ant-picker-focused {
    border-color: ${(props) => props.theme[props.brand].formInput.singInputBg};
    box-shadow: none;
  }
  .ant-picker-input:focus {
    box-shadow: none;
    border-color: ${(props) => props.theme[props.brand].formInput.singInputBg};
  }
  .ant-picker-content {
    background: red !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 1px solid
      ${(props) => props.theme[props.brand].formInput.singInputBg};
  }
  /* 类似于/cm/ml页面的data-picker样式开始 */
  .detail_datapicker {
    margin-bottom: 0;
    .ant-form-item-label {
      margin-right: 0;
    }
    .ant-form-item-no-colon {
      text-align: left;
      width: 169px;
      font-size: 16px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      background: ${(props) => props.theme[props.brand].dataPicker.labelColor};
      display: inline-block;
      height: ${(props) => props.height};
      color: ${(props) => props.theme[props.brand].dataPicker.color};
      line-height: ${(props) => props.height};
      padding-left: 13px;
      border: 1px solid
        ${(props) => props.theme[props.brand].dataPicker.borderDisColor};
      border-right: none;
    }
    .ant-picker-input,
    .ant-picker-input span,
    .ant-picker,
    input {
      background-color: ${(props) =>
        props.theme[props.brand].dataPicker.inputBg};
    }
    input {
      height: calc(${(props) => props.height} - 2px);
    }
    .ant-picker.ant-picker-disabled {
      border-color: ${(props) =>
        props.theme[props.brand].dataPicker.borderDisColor};
      cursor: default;
    }
    input[disabled] {
      cursor: default;
    }
  }
  /* 选中可编辑的样式 */
  .detail_edit {
    .ant-picker-input,
    .ant-picker-input span,
    .ant-picker,
    input {
      background-color: ${(props) =>
        props.theme[props.brand].dataPicker.inputBg};
    }
  }
  .detail {
    .ant-picker-input,
    .ant-picker-input span,
    .ant-picker,
    input {
      background-color: ${(props) =>
        props.theme[props.brand].dataPicker.inputBg};
      color: ${(props) =>
        props.theme[props.brand].dataPicker.dataDisColor} !important;
    }
  }
  .detail_disadled {
    .ant-picker-input,
    .ant-picker-input span,
    .ant-picker,
    input {
      background-color: ${(props) =>
        props.theme[props.brand].dataPicker.dataDisBg};
      color: ${(props) =>
        props.theme[props.brand].dataPicker.dataDisColor} !important;
    }
  }
  /* 类似于/cm/ml页面的data-picker样式结束 */
`;
